import { render, staticRenderFns } from "./ModifyLivenessDetectionPopup.vue?vue&type=template&id=14c40baa&"
import script from "./ModifyLivenessDetectionPopup.vue?vue&type=script&lang=js&"
export * from "./ModifyLivenessDetectionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports